export default 
{
    
"Men’s Clothing": [
    "T-Shirts",
    "Shirts",
    "Blazers",
	"Sweaters ",
	"Jeans",
	"Pants",
	"Shorts",
	"Coats & Jackets",
	"Suits",
	"Athletic Apparel",
	"Socks",
	"Underwear",
	"Shoes"

],
    

"Women’s Clothing": [
    "Dresses",
    "Tops & Blouses",
	"T- Shirts",
	"Sweaters",
	"Coats & Jackets",
	"Jeans",
	"Pants",
	"Shorts",
	"Skirts",
	"Swimwear",
	"Intimates & Sleepwear" 

    ],


"Kids & Baby": [
	"Girls (newborn - 5T)",
	"Girls (4 and Up)" ,
	"Boys (newborn -5T)",
	"Boys (4 and Up)"


],

"Men’s Accessories":[
	"Sunglasses",
	"Wallets",
	"Scarves & Wraps",
	"Watches",
	"Belts",
	"Hats",
	"Caps",
	"Gloves & Mittens",		

],

"Women’s Accessories":[
	"Sunglasses",
	"Wallets",
	"Scarves & Wraps",
	"Watches",
	"Belts",
	"Hats",
	"Caps",
	"Gloves & Mittens",	

],


}


// WEBPACK FOOTER //
// ./src/data/ClothingAccessories.js